import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { BAND_PATHS } from "Bands/router";
import { SessionStorageService } from "shared/services/SessionStorageService";

export const useBandIdFromPath = () => {
  const { pathname } = useLocation();

  const bandId = useMemo(() => {
    // exclude create band path as it does not have an id
    if (pathname !== BAND_PATHS.CREATE_BAND) {
      const paths = pathname.split("/");

      if (paths.length > 2 && paths[1] === "band") {
        SessionStorageService.setItem("selectedBand", paths[2] as string);
        return paths[2];
      }

      const selectedBand = SessionStorageService.getItem("selectedBand");

      if (selectedBand && paths[1] === "venue") {
        return selectedBand;
      }
    }

    return null;
  }, [pathname]);

  return bandId;
};
